import styled from "styled-components";
import { Button } from "reactstrap";

export default {
  button: styled(Button)`
    margin: 0 0 15px 0;
  `
};
